<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="grid grid-cols-12 container py-5">
            <div class="col-span-10">
                <b-form-input ref="focusMe" class="h-11 border-gray-300 focus:ring-0" type="number"  v-model="saleId"></b-form-input>
            </div>
            <div class="col-span-2">
                <button @click="searchSale" class="bg-main border-0 hover:bg-hoverMain rounded-r -ml-1 cursor-pointer h-11 w-full focus:outline-none" :disabled="saleId === null || saleId === '' || saleId === '0'">
                    <img src="/images/search1.png" alt="" class="h-6 cursor-pointer">
                </button>
            </div>
        </div>


        <div v-if="hasSale">
            <table class="w-full">
                <thead class="h-11 bg-lightGray">
                <tr>
                    <th class="d-none d-sm-table-cell pl-3">#</th>
                    <th>{{ $t('product.title') }}</th>
                    <th class="d-none d-sm-table-cell">{{ $t('amount') }}</th>
                    <th class="px-3">{{ $t('returnProducts.returnAmount') }}</th>
                    <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                    <th class="d-none d-sm-table-cell">{{ $t('sale.sum') }}</th>
                </tr>
                </thead>
                <tbody
                    v-for="(saleProduct, index) in saleProducts"
                    :key="index"
                    :style="isRefresh ? 'margin-top: 1px' : 'margin-top: 0'"
                >
                <tr class="h-11">
                    <td class="d-none d-sm-table-cell pl-3"> {{saleProduct.id}}</td>
                    <td>
                        {{saleProduct.product.name}}
                    </td>
                    <td
                        :style="saleProduct.isErrorColors === true ? 'color: red; font-size: 18px' : 'color: #212529;'"
                        class="d-none d-sm-table-cell"
                    >
                        {{ parseFloat(saleProduct.amount) + ' ' + showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                    </td>
                    <td class="w-64 px-3">
                        <div class="flex">
                            <img src="/images/Minus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="minusAmount(index), changeInput(saleProduct.amount, saleProduct.returnAmount)">
                            <input
                                class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-full bg-mediumGray focus:outline-none text-center text-main font-bold"
                                v-model="saleProduct.returnAmount"
                                @change="changeInput(saleProduct.amount, saleProduct.returnAmount)"
                            >
                            <span class="h-5 lg:h-7 bg-mediumGray w-12 lg:w-20 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                 {{' ' + showUnitOfMeasure(saleProduct.product.unitOfMeasure)}}
                            </span>
                            <img src="/images/Plus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="plusAmount(saleProduct.amount, index), changeInput(saleProduct.amount, saleProduct.returnAmount)">
                        </div>
                        <div v-if="saleProduct.returnAmount > saleProduct.amount || saleProduct.isErrorAmount" class="text-red-500 text-xs flex justify-center">
                            {{$t('returnProducts.deficitQuantity')}}
                        </div>
                    </td>
                    <td class="d-none d-sm-table-cell">
                        {{ showCurrencyById(getSale.currency.id, saleProduct.price / saleProduct.amount) }}
                    </td>
                    <td class="d-none d-sm-table-cell">
                        {{ showCurrencyById(getSale.currency.id, (saleProduct.price / saleProduct.amount) * saleProduct.returnAmount) }}
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="grid grid-cols-12 gap-3 container py-4">
                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('returnProducts.totalSum')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(getSale.currency.id, getSale.totalPrice - totalPrice) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('returnProducts.returnSum')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(getSale.currency.id, totalPrice) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative mt-2">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('customer.title')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{getCustomerName(getSale)}}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative mt-2">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('date')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ this.time }} {{ date }}
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-3 container pb-4">
                <div class="col-span-4">
                    <b-button
                        class="w-full border-0 h-11 bg-gray-400 focus:ring-0 font-bold hover:bg-gray-400"
                    >
                        {{modelForm.refundAmount}} {{$t('returnProducts.typeProduct')}}
                    </b-button>
                </div>

                <div class="col-span-4">
                    <b-button
                        :disabled="isErrorAmount || modelForm.refundAmount === 0"
                        @click="saleRefund"
                        class="w-full border-0 h-11 bg-main focus:ring-0 font-bold"
                    >
                        {{ $t('returnProducts.return') }}
                    </b-button>
                </div>

                <div class="col-span-4">
                    <b-button
                        :disabled="modelForm.refundAmount === 0"
                        @click="cancelReturn()"
                        class="w-full border-0 h-11 bg-denyColor focus:ring-0 font-bold"
                    >
                        {{$t('sale.transaction.cancel')}}
                    </b-button>
                </div>
            </div>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Row from "../../components/html/Row";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import accessMixin from "@/mixin/accessMixin";

export default {
    name: "Add",
    components: {
        Row,
    },
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormatting, accessMixin],
    data() {
        return {
            isLoading: false,
            isErrorAmount: false,
            interval: null,
            time: null,
            date: null,
            weekday: null,
            isRefresh: false,
            hasSale: false,
            saleProducts: [],
            totalPrice: 0,
            totalAmount: 0,
            saleId: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'returnProducts.return', url: 'saleRefund'},
                {name: 'returnProducts.newReturn'},
            ],
            modelForm: {
                saleId: null,
                customer: null,
                refundAmount: 0,
                refundPrice: 0,
                currency: null,
                refundSaleProductsDtos: []
            },
        }
    },
    computed: {
        ...mapGetters(['getSale']),
    },
    methods: {
        ...mapActions(['fetchSale', 'pushSaleRefund', 'setBreadcrumbItems']),
        changeInput(amount, returnAmount){
            this.isErrorAmount = returnAmount > amount;
        },
        getCustomerName(item) {
            return item.customer.isCompany ?
                item.customer.customerCompany.name :
                item.customer.person.givenName + ' ' + item.customer.person.familyName
        },
        cancelReturn() {
            this.saleProducts = this.getSale.saleProducts

            for(let saleProduct of this.saleProducts) {
                saleProduct.returnAmount = 0.0
            }

            this.modelForm.refundAmount = 0
            this.isRefresh = !this.isRefresh
        },
        returnProductAmount () {
            this.modelForm.refundAmount = 0

            for (let sale of this.saleProducts) {
                if( sale.returnAmount > 0) {
                    this.modelForm.refundAmount++
                }
            }
        },
        calcTotalPrice () {
            this.totalPrice = null

            for (let sale of this.saleProducts) {
                this.totalPrice += ((sale.price / sale.amount) * sale.returnAmount)
            }
        },
        minusAmount(index) {
            if (this.saleProducts[index].returnAmount > 0) {
                this.saleProducts[index].returnAmount--
            }

            this.returnProductAmount()
            this.calcTotalPrice()
            this.isRefresh = !this.isRefresh
        },
        plusAmount(amount, index) {
            if (this.saleProducts[index].returnAmount < amount) {
                this.saleProducts[index].returnAmount ++
            } else {
                this.saleProducts[index].isErrorAmount = true
                this.saleProducts[index].isErrorColors = true
                setTimeout(() => {
                    this.saleProducts[index].isErrorColors = false
                    this.isRefresh = !this.isRefresh
                }, 400)
                setTimeout(() => {
                    this.saleProducts[index].isErrorAmount = false
                    this.isRefresh = !this.isRefresh
                }, 2000)
            }

            this.returnProductAmount()
            this.calcTotalPrice()
            this.isRefresh = !this.isRefresh
        },
        fetchSaleProduct() {
            this.saleProducts = []

            for(let saleProduct of this.getSale.saleProducts) {
                if(saleProduct.amount !== "0.0000") {
                    saleProduct.returnAmount = 0.0
                    saleProduct.isErrorAmount = false
                    saleProduct.isErrorColors = false
                    this.saleProducts.push(saleProduct)
                }
            }
        },
        searchSale() {
            console.log('Ishhh')
            this.$root.showOverlay = true
            this.isLoading = true

            if(this.saleId !== null) {
                this.fetchSale(this.saleId)
                    .then(() => {
                        this.fetchSaleProduct()
                        this.hasSale = true
                    })
                    .catch(() => {
                        this.$i18nHelper.flash(this.$t('notInfo'), 'warning')
                    })
                    .finally(() => {
                        this.isLoading = false
                        this.$root.showOverlay = false
                    })
            }
        },
        realtimeClock() {
            // update the time every second
            this.interval = setInterval(() => {
                // Concise way to format time according to system locale.
                // In this case it returns "17:25:00"
                this.time = Intl.DateTimeFormat(navigator.language, {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit',
                }).format()
            }, 1000)
        },
        getFullDate() {
            this.date = this.dateFormat(new Date().toDateString())
            // array of week days
            let days = [this.$t('statistics.weekday.sun'), this.$t('statistics.weekday.mon'), this.$t('statistics.weekday.tue'), this.$t('statistics.weekday.wed'), this.$t('statistics.weekday.thu'), this.$t('statistics.weekday.fri'), this.$t('statistics.weekday.sat')];
            let d = new Date();
            this.weekday = days[d.getDay()]
        },
        preparationSaleRefund() {
            this.modelForm.refundSaleProductsDtos = []
            this.modelForm.saleId = this.getSale.id
            this.modelForm.customer = this.getSale.customer['@id']
            this.modelForm.currency = this.getSale.currency['@id']
            this.modelForm.refundPrice = this.totalPrice

            for (let saleProduct of this.saleProducts) {
                if(saleProduct.returnAmount > 0) {
                    this.modelForm.refundSaleProductsDtos.push({
                        saleProductId: saleProduct.id,
                        returnAmount: saleProduct.returnAmount,
                        refundPrice: saleProduct.returnAmount * (saleProduct.price / saleProduct.amount),
                        product: saleProduct.product['@id']
                    })
                }
            }
        },
        saleRefund() {
            this.preparationSaleRefund()
            this.addSaleRefund()
        },
        addSaleRefund() {
            if(this.modelForm.refundAmount > 0) {
                this.pushSaleRefund(this.modelForm)
                    .then(() => {
                        this.$i18nHelper.toUrl('saleRefund')
                    })
                    .catch(() => {
                        this.$i18nHelper.flash(this.$t('unknownError'), 'warning')
                    })
            }
        }
    },
    created() {
        this.realtimeClock()
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$nextTick(() => this.$refs.focusMe.focus())
        this.getFullDate()
    },
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.text-light span {
    font-size: 12px;
}

.list-product .right {
    text-align: right;
}

.list-product .center {
    text-align: center;
}

.input-amount {
    border-top: 1px solid #c5c5c5;
    border-bottom: 1px solid #c5c5c5;
    box-shadow: none !important;
    height: 22px;
}

.minus {
    background-color: #6f42c1;
    cursor: pointer;
    padding-left: 3px;
}

.plus {
    background-color: #6f42c1;
    cursor: pointer;
}

.awesome-icon-amount {
    color: #FFFFFF;
    font-weight: 100;
    font-size: 15px;
}

.product-card > span {
    display: flex;
    justify-content: center;
    justify-self: center;
    margin-top: 6px;
}
</style>
